module.exports = __webpack_public_path__ + "MaterialIcons-Regular.a37b0c01c0baf1888ca8.ttf";


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/@covalent/core/common/styles/font/MaterialIcons-Regular.ttf
// module id = ../../../../@covalent/core/common/styles/font/MaterialIcons-Regular.ttf
// module chunks = 2